import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/two-factor/check")({
  component: () => <Navigate to="/" replace />,
});
